import { render, staticRenderFns } from "./whitespace.vue?vue&type=template&id=b110cf8e"
import script from "./whitespace.vue?vue&type=script&lang=js"
export * from "./whitespace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports